export const FOOTER_ID = 'serviceFooter';
